<div class="action-config-wrapper" style="max-width: 550px">
  <div class="config-action">
    <div class="mb-2">
      <label class="form-label label d-flex" style="align-items: center"
        ><span>Language</span>
        <nb-icon
          class="ms-1"
          style="color: #929bb3; width: 15px"
          nbTooltip="Set the default language for flow."
          nbTooltipPlacement="bottom"
          nbTooltipStatus="basic"
          icon="question-mark-circle-outline"
        >
        </nb-icon
      ></label>
      <div>
        <nb-radio-group
          [(ngModel)]="data.languageOption"
          class="choice-option mb-2 radio row ps-4"
          name="radio-group-language"
        >
          <nb-radio value="listLang" class="col-md-4 p-0"
            >From List Language</nb-radio
          >
          <nb-radio value="variable" class="col-md-4 p-0"
            >From Variable</nb-radio
          >
        </nb-radio-group>
      </div>
      <div *ngIf="data.languageOption == 'variable'">
        <ngx-input-value-static
          selectAttribute="true"
          [propertyInput]="data.languageAttribute"
          (propertyEmit)="getLangVariable($event)"
          [errorMessage]="errorMessage"
        >
        </ngx-input-value-static>
      </div>

      <nb-select
        *ngIf="data.languageOption == 'listLang'"
        fullWidth
        placeholder="Select Language"
        [(ngModel)]="data.language"
        size="small"
      >
        <nb-option *ngFor="let item of listlanguage" [value]="item?.language"
          >{{ item?.name }}
        </nb-option>
      </nb-select>
    </div>
    <form class="mb-2" [formGroup]="formGroup">
      <label class="form-label label d-flex" style="align-items: center">
        <span class="required">Audio Path</span>
        <nb-icon
          class="ms-1"
          style="color: #929bb3; width: 15px"
          nbTooltip="The path to the audio file, the path can be a variable."
          nbTooltipPlacement="bottom"
          nbTooltipStatus="basic"
          icon="question-mark-circle-outline"
        >
        </nb-icon>
      </label>
      <input
        formControlName="input"
        type="text"
        nbInput
        fullWidth
        id="input-audio-path"
        placeholder="Audio Path"
        fieldSize="small"
        [mention]="attributes"
        [(ngModel)]="data.input"
        [mentionConfig]="mentionConfig"
        [status]="
          formGroup.get('input').invalid &&
          (formGroup.get('input').dirty || formGroup.get('input').touched)
            ? 'danger'
            : 'basic'
        "
      />
      <ng-container
        *ngIf="
          formGroup.get('input').invalid &&
          (formGroup.get('input').dirty || formGroup.get('input').touched)
        "
      >
        <p
          class="caption status-danger"
          style="margin-bottom: 0"
          *ngIf="
            formGroup.get('input').hasError('required') ||
            formGroup.get('input').hasError('whitespace')
          "
        >
          Audio Path is required.
        </p>
      </ng-container>
    </form>
    <div class="form-group mb-3">
      <label class="label required">Transcribed Output</label>
      <ngx-input-value-static
        selectAttribute="true"
        [propertyInput]="data.transcriptionVariable"
        (propertyEmit)="getOutputVariable($event)"
        [errorMessage]="'Transcribed Output is required'"
      >
      </ngx-input-value-static>
    </div>
    <div class="mb-2" style="display: flex; align-items: center">
      <nb-toggle
        [(checked)]="data.isConversation"
        status="basic"
        (checkedChange)="onConversationModeChange($event)"
      >
        Conversation Mode
      </nb-toggle>
      <nb-icon
        class="ms-2"
        style="color: #929bb3; width: 15px"
        nbTooltip="Enable to transcribe conversations between speakers."
        nbTooltipPlacement="bottom"
        nbTooltipStatus="basic"
        nbTooltipTrigger="hover"
        icon="question-mark-circle-outline"
      >
      </nb-icon>
    </div>
    <div class="config-section" *ngIf="data.isConversation">
      <div class="speakers-container" [formGroup]="speakerForm">
        <div class="row">
          <!-- Speaker 1 -->
          <div class="col-6">
            <div class="speaker-input-group">
              <div class="speaker-input-container">
                <label class="label required">Speaker Name 1</label>
                <input
                  type="text"
                  nbInput
                  fullWidth
                  fieldSize="small"
                  formControlName="speaker1"
                  placeholder="Speaker Name 1"
                  [mention]="attributes"
                  [mentionConfig]="mentionConfig"
                  class="speaker-input"
                  [status]="
                    speakerForm.get('speaker1').invalid &&
                    speakerForm.get('speaker1').touched
                      ? 'danger'
                      : 'basic'
                  "
                />
                <ng-container
                  *ngIf="
                    speakerForm.get('speaker1').invalid &&
                    speakerForm.get('speaker1').touched
                  "
                >
                  <p
                    class="caption status-danger"
                    *ngIf="speakerForm.get('speaker1').errors?.maxlength"
                  >
                    Speaker Name 1 must not exceed 20 characters
                  </p>
                  <p
                    class="caption status-danger"
                    *ngIf="
                      speakerForm.get('speaker1').errors?.required ||
                      speakerForm.get('speaker1').errors?.whitespace
                    "
                  >
                    Speaker Name 1 is required
                  </p>
                </ng-container>
              </div>
            </div>
          </div>

          <!-- Speaker 2 -->
          <div class="col-6">
            <div class="speaker-input-group">
              <div class="speaker-input-container">
                <label class="label required">Speaker Name 2</label>
                <input
                  type="text"
                  nbInput
                  fullWidth
                  fieldSize="small"
                  formControlName="speaker2"
                  placeholder="Speaker Name 2"
                  [mention]="attributes"
                  [mentionConfig]="mentionConfig"
                  class="speaker-input"
                  [status]="
                    speakerForm.get('speaker2').invalid &&
                    speakerForm.get('speaker2').touched
                      ? 'danger'
                      : 'basic'
                  "
                />
                <ng-container
                  *ngIf="
                    speakerForm.get('speaker2').invalid &&
                    speakerForm.get('speaker2').touched
                  "
                >
                  <p
                    class="caption status-danger"
                    *ngIf="speakerForm.get('speaker2').errors?.maxlength"
                  >
                    Speaker Name 2 must not exceed 20 characters
                  </p>
                  <p
                    class="caption status-danger"
                    *ngIf="
                      speakerForm.get('speaker2').errors?.required ||
                      speakerForm.get('speaker2').errors?.whitespace
                    "
                  >
                    Speaker Name 2 is required
                  </p>
                </ng-container>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="form-group mb-3 mt-2" *ngIf="data.isConversation">
      <label class="label">Output Format</label>
      <nb-icon
        class="ms-1"
        style="color: #929bb3; width: 15px"
        [nbPopover]="templateRef"
        nbPopoverPlacement="bottom"
        nbPopoverTrigger="hover"
        icon="question-mark-circle-outline"
      >
      </nb-icon>
      <nb-select
        fullWidth
        [ngModel]="data.format"
        (ngModelChange)="onFormatChange($event)"
        size="small"
      >
        <nb-option value="raw">Raw Text</nb-option>
        <nb-option value="json">JSON</nb-option>
      </nb-select>
    </div>
  </div>
</div>

<footer-action
  (handleCancelAction)="handleCancelAction()"
  (handleSaveAction)="handleSaveAction()"
></footer-action>

<ng-template #templateRef>
  <nb-card style="max-width: 500px; margin-bottom: 0; max-height: 500px">
    <nb-card-body style="font-size: 13px">
      <div style="margin-bottom: 0.5rem">
        The transcription result can be formatted in two ways:
      </div>

      <div style="margin-bottom: 0.5rem">
        <strong>1. Raw Text Format:</strong>
        <pre
          style="
            background: #f5f5f5;
            padding: 10px;
            border-radius: 4px;
            margin-top: 5px;
          "
        >
          John: How do you feel today?
          David: I'm feeling great!</pre
        >
      </div>

      <div style="margin-bottom: 0.5rem">
        <strong>2. JSON Format:</strong>
        <pre
          style="
            background: #f5f5f5;
            padding: 10px;
            border-radius: 4px;
            margin-top: 5px;
          "
          >{{ jsonExample }}</pre
        >
      </div>

      <div style="margin-top: 1rem">
        <strong>Note:</strong> JSON format includes additional metadata like
        timing information for each utterance, while Raw format provides a
        simple, readable conversation transcript.
      </div>
    </nb-card-body>
  </nb-card>
</ng-template>
